// MANDASA JS START

(function () {
  
  if (window.innerWidth > 500) return;

  function loadjQuery(callback) {
    if (window.jQuery) return callback();
    const script = document.createElement('script');
    script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
    script.onload = callback;
    script.onerror = () => console.error('Failed to load jQuery.');
    document.head.appendChild(script);
  }


  const originalAttachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    const shadowRoot = originalAttachShadow.call(this, init);
    this._shadowRoot = shadowRoot;
    return shadowRoot;
  };

  function applyMobileStyles() {
    const host = document.querySelector('.sel-embedded.sel-footer-left');
    if (!host || !host._shadowRoot) {
      return setTimeout(applyMobileStyles, 300);
    }

    const $target = $(host._shadowRoot).find('.sc-hvigdm.fOjyrj.sel-bothContainer');
    if ($target.length) {
      $target.css({
        'flex-wrap': 'wrap',
        'justify-content': 'center'
      });
    
      return true;
    } else {
      
      setTimeout(applyMobileStyles, 300);
    }
  }

  window.addEventListener('DOMContentLoaded', () => {
    loadjQuery(() => applyMobileStyles());
  });
})();


// MANDASA JS END